module.exports = __webpack_public_path__ + "static/media/AD_Logo_AWP-1.bbaa9002.png";